export default __webpack_public_path__ + "static/media/travel_and_tours.0ef68929.jpg";